// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/add_new_topic.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../statics/add_new_topic_active.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideBarNewChatButton_container__TqKoG  {
    width: 100%;
    height: 100%;
}

.SideBarNewChatButton_img__u8W6P {
    width: 20px;
    height: 20px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
    transition: background 0.5s;
}

.SideBarNewChatButton_img__u8W6P::after {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.SideBarNewChatButton_text__0B85V {
    font-size: 14px;
    color: #17A8B5;
    margin-left: 10px;
    transition: color 0.5s;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/SideBarNewChatButton/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gFAAqF;IACrF,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,gFAA4F;IAC5F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B","sourcesContent":[".container  {\n    width: 100%;\n    height: 100%;\n}\n\n.img {\n    width: 20px;\n    height: 20px;\n    background: url('../../../../statics/add_new_topic.png') no-repeat center / 100% 100%;\n    transition: background 0.5s;\n}\n\n.img::after {\n    content: \"\";\n    background: url('../../../../statics/add_new_topic_active.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.text {\n    font-size: 14px;\n    color: #17A8B5;\n    margin-left: 10px;\n    transition: color 0.5s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SideBarNewChatButton_container__TqKoG`,
	"img": `SideBarNewChatButton_img__u8W6P`,
	"text": `SideBarNewChatButton_text__0B85V`
};
export default ___CSS_LOADER_EXPORT___;
